/**
 * Generated by orval v8.23.0 🍺
 * Do not edit manually.
 * RapidWorks.UserManagement.WebApi | v1
 * OpenAPI spec version: 1.0.0
 */
import { useQuery } from '@tanstack/react-query';
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseQueryOptions,
  UseQueryResult
} from '@tanstack/react-query';

import { axiosInstance } from '../../axios-instance.ts';

type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];

const withQueryKey = <T extends object, K>(query: T, queryKey: K): T & { queryKey: K } => {
  const result = { queryKey } as T & { queryKey: K };
  for (const key of Object.keys(query)) {
    // The explicit queryKey always wins, matching the previous
    // `{ ...query, queryKey }` spread where it was set last.
    if (key === 'queryKey') continue;
    Object.defineProperty(result, key, {
      enumerable: true,
      configurable: true,
      get: () => (query as Record<string, unknown>)[key]
    });
  }
  return result;
};

export const getApiUserManagementV1CustomerDatabaseGroups = (options?: SecondParameter<typeof axiosInstance>, signal?: AbortSignal) => {
  return axiosInstance<void>({ url: `/api/user-management/v1/customer-database-groups`, method: 'GET', signal }, options);
};

export const getGetApiUserManagementV1CustomerDatabaseGroupsQueryKey = () => {
  return [`/api/user-management/v1/customer-database-groups`] as const;
};

export const getGetApiUserManagementV1CustomerDatabaseGroupsQueryOptions = <
  TData = Awaited<ReturnType<typeof getApiUserManagementV1CustomerDatabaseGroups>>,
  TError = unknown
>(options?: {
  query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiUserManagementV1CustomerDatabaseGroups>>, TError, TData>>;
  request?: SecondParameter<typeof axiosInstance>;
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetApiUserManagementV1CustomerDatabaseGroupsQueryKey();

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getApiUserManagementV1CustomerDatabaseGroups>>> = ({ signal }) =>
    getApiUserManagementV1CustomerDatabaseGroups(requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getApiUserManagementV1CustomerDatabaseGroups>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetApiUserManagementV1CustomerDatabaseGroupsQueryResult = NonNullable<
  Awaited<ReturnType<typeof getApiUserManagementV1CustomerDatabaseGroups>>
>;
export type GetApiUserManagementV1CustomerDatabaseGroupsQueryError = unknown;

export function useGetApiUserManagementV1CustomerDatabaseGroups<
  TData = Awaited<ReturnType<typeof getApiUserManagementV1CustomerDatabaseGroups>>,
  TError = unknown
>(
  options: {
    query: Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiUserManagementV1CustomerDatabaseGroups>>, TError, TData>> &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiUserManagementV1CustomerDatabaseGroups>>,
          TError,
          Awaited<ReturnType<typeof getApiUserManagementV1CustomerDatabaseGroups>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof axiosInstance>;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetApiUserManagementV1CustomerDatabaseGroups<
  TData = Awaited<ReturnType<typeof getApiUserManagementV1CustomerDatabaseGroups>>,
  TError = unknown
>(
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiUserManagementV1CustomerDatabaseGroups>>, TError, TData>> &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiUserManagementV1CustomerDatabaseGroups>>,
          TError,
          Awaited<ReturnType<typeof getApiUserManagementV1CustomerDatabaseGroups>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof axiosInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetApiUserManagementV1CustomerDatabaseGroups<
  TData = Awaited<ReturnType<typeof getApiUserManagementV1CustomerDatabaseGroups>>,
  TError = unknown
>(
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiUserManagementV1CustomerDatabaseGroups>>, TError, TData>>;
    request?: SecondParameter<typeof axiosInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

export function useGetApiUserManagementV1CustomerDatabaseGroups<
  TData = Awaited<ReturnType<typeof getApiUserManagementV1CustomerDatabaseGroups>>,
  TError = unknown
>(
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiUserManagementV1CustomerDatabaseGroups>>, TError, TData>>;
    request?: SecondParameter<typeof axiosInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetApiUserManagementV1CustomerDatabaseGroupsQueryOptions(options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}

export const getApiUserManagementV1CustomerDatabaseGroupsId = (
  id: number,
  options?: SecondParameter<typeof axiosInstance>,
  signal?: AbortSignal
) => {
  return axiosInstance<void>({ url: `/api/user-management/v1/customer-database-groups/${id}`, method: 'GET', signal }, options);
};

export const getGetApiUserManagementV1CustomerDatabaseGroupsIdQueryKey = (id: number) => {
  return [`/api/user-management/v1/customer-database-groups/${id}`] as const;
};

export const getGetApiUserManagementV1CustomerDatabaseGroupsIdQueryOptions = <
  TData = Awaited<ReturnType<typeof getApiUserManagementV1CustomerDatabaseGroupsId>>,
  TError = unknown
>(
  id: number,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiUserManagementV1CustomerDatabaseGroupsId>>, TError, TData>>;
    request?: SecondParameter<typeof axiosInstance>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetApiUserManagementV1CustomerDatabaseGroupsIdQueryKey(id);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getApiUserManagementV1CustomerDatabaseGroupsId>>> = ({ signal }) =>
    getApiUserManagementV1CustomerDatabaseGroupsId(id, requestOptions, signal);

  return { queryKey, queryFn, enabled: id !== null && id !== undefined, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getApiUserManagementV1CustomerDatabaseGroupsId>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetApiUserManagementV1CustomerDatabaseGroupsIdQueryResult = NonNullable<
  Awaited<ReturnType<typeof getApiUserManagementV1CustomerDatabaseGroupsId>>
>;
export type GetApiUserManagementV1CustomerDatabaseGroupsIdQueryError = unknown;

export function useGetApiUserManagementV1CustomerDatabaseGroupsId<
  TData = Awaited<ReturnType<typeof getApiUserManagementV1CustomerDatabaseGroupsId>>,
  TError = unknown
>(
  id: number,
  options: {
    query: Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiUserManagementV1CustomerDatabaseGroupsId>>, TError, TData>> &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiUserManagementV1CustomerDatabaseGroupsId>>,
          TError,
          Awaited<ReturnType<typeof getApiUserManagementV1CustomerDatabaseGroupsId>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof axiosInstance>;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetApiUserManagementV1CustomerDatabaseGroupsId<
  TData = Awaited<ReturnType<typeof getApiUserManagementV1CustomerDatabaseGroupsId>>,
  TError = unknown
>(
  id: number,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiUserManagementV1CustomerDatabaseGroupsId>>, TError, TData>> &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiUserManagementV1CustomerDatabaseGroupsId>>,
          TError,
          Awaited<ReturnType<typeof getApiUserManagementV1CustomerDatabaseGroupsId>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof axiosInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetApiUserManagementV1CustomerDatabaseGroupsId<
  TData = Awaited<ReturnType<typeof getApiUserManagementV1CustomerDatabaseGroupsId>>,
  TError = unknown
>(
  id: number,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiUserManagementV1CustomerDatabaseGroupsId>>, TError, TData>>;
    request?: SecondParameter<typeof axiosInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

export function useGetApiUserManagementV1CustomerDatabaseGroupsId<
  TData = Awaited<ReturnType<typeof getApiUserManagementV1CustomerDatabaseGroupsId>>,
  TError = unknown
>(
  id: number,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiUserManagementV1CustomerDatabaseGroupsId>>, TError, TData>>;
    request?: SecondParameter<typeof axiosInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetApiUserManagementV1CustomerDatabaseGroupsIdQueryOptions(id, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}
